import axios from "axios"
import router from "../router"
const instance = axios.create({
    baseURL: process.env["VUE_APP_BASE_URL"],
    timeout: 5000,
    headers: {
        "Content-Type": "application/json"
    }
});

const routerList=['/HomeView','/szbj','/sx','/sjfw','/gywm','login']
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // console.log();
    
    if(routerList.includes(router.app._route.path)){
        return config;
    }
    // 在发送请求之前做些什么
    if(sessionStorage.getItem('token')){
      config.headers.Authorization=sessionStorage.getItem('token')
      return config
    }
    config.headers.Authorization=localStorage.getItem('token')
    return config
 
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response.data.data;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  });

export default instance